import {isObjectNullOrEmpty} from "../Utilities/Types/objectUtilities";

export function isValidUser(user) {
    return !isObjectNullOrEmpty(user) && !!user.userId && user.userId > 0;
}
